import { useEffect, useRef } from 'react';
import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { toast } from 'react-toastify';

export type HumanTakeoverNotification = {
  orderId: number;
  sessionId: string;
  subOrgId: string;
};

interface UseHumanTakeoverSocketOptions {
  subOrgId: string | undefined;
  onTakeover: (notification: HumanTakeoverNotification) => void;
}

export function useHumanTakeoverSocket({ subOrgId, onTakeover }: UseHumanTakeoverSocketOptions) {
  const clientRef = useRef<Client | null>(null);

  useEffect(() => {
    if (!subOrgId) return undefined;

    const client = new Client({
      webSocketFactory: () => new SockJS('http://localhost:8080/ws'),
      reconnectDelay: 5000,
      onConnect: () => {
        client.subscribe(`/topic/orders/${subOrgId}/human-takeover`, (message) => {
          try {
            const notification: HumanTakeoverNotification = JSON.parse(message.body);
            toast.warning(`🙋 Un client demande de l'aide (commande #${notification.orderId})`, {
              position: 'top-right',
              autoClose: 8000,
              toastId: `takeover-${notification.orderId}`,
            });
            onTakeover(notification);
          } catch (e) {
            console.error('[HumanTakeoverSocket] Erreur parsing message:', e);
          }
        });
      },
      onStompError: (frame) => {
        console.error('[HumanTakeoverSocket] Erreur STOMP:', frame);
      },
      onWebSocketError: (error) => {
        console.warn('[HumanTakeoverSocket] WebSocket indisponible (backend non démarré?):', error);
      },
    });

    client.activate();
    clientRef.current = client;

    return () => {
      client.deactivate();
      clientRef.current = null;
    };
  }, [subOrgId, onTakeover]);
}
